import { render, staticRenderFns } from "./AdminCampaignsFilter.vue?vue&type=template&id=0c0e3455&scoped=true&"
import script from "./AdminCampaignsFilter.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignsFilter.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCampaignsFilter.vue?vue&type=style&index=0&id=0c0e3455&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e3455",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
